var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickerPause01 = function SvgTickerPause01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #b45fff;\n      }"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a98320b4-c804-49e8-bb64-e76768f68178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.57,21.43v157.14c0,11.83-9.59,21.43-21.43,21.43h-7.14c-11.83,0-21.43-9.59-21.43-21.43V21.43C28.57,9.59,38.17,0,50,0h7.14c11.83,0,21.43,9.59,21.43,21.43ZM150,0h-7.14c-11.83,0-21.43,9.59-21.43,21.43v157.14c0,11.83,9.59,21.43,21.43,21.43h7.14c11.83,0,21.43-9.59,21.43-21.43V21.43c0-11.83-9.59-21.43-21.43-21.43Z"
  }))));
};
export default SvgTickerPause01;